module.exports = __webpack_public_path__ + "img/4.a2db92e0.jpg";